import { createContext } from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { getLocalStorageItem, setLocalStorageItem } from '../utils/helper';
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isShow, setShow] = useState(true);

  /**
   * Whether the desktop sidebar is narrowed to its icon rail.
   *
   * Remembered across reloads because it is a working preference, not a view
   * state: someone who narrows the nav to get more room for a wide table wants
   * it narrow on the next page too, and re-collapsing it on every load would
   * make the control feel broken. Separate from `isShow`, which is the mobile
   * drawer and is always driven by the current screen width.
   */
  const [isCollapsed, setIsCollapsed] = useState(
    () => JSON.parse(getLocalStorageItem('sidebarCollapsed')) || false
  );
  const [isDarkModeEnabled, setIsDarkModeEnabled] = useState(
    JSON.parse(getLocalStorageItem('selectedTheme')) ? true : false
  );

  const [showMemberOptions, setShowMemberOptions] = useState(() => {
    const userData = JSON.parse(getLocalStorageItem('userData'));
    const userCompanyId = userData?.companyId;
    const companiesWithMember = process.env.REACT_APP_COMPANIES_WITH_MEMBER
      ? process.env.REACT_APP_COMPANIES_WITH_MEMBER.split(',').map(id => id.trim())
      : [];
    return userCompanyId && companiesWithMember.includes(userCompanyId);
  }); // New state for member options visibility
  const [isB2BFansMode, setIsB2BFansMode] = useState(
    JSON.parse(getLocalStorageItem('isB2BFansMode')) || false
  );
  if (isDarkModeEnabled) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }

  setLocalStorageItem('selectedTheme', isDarkModeEnabled);
  setLocalStorageItem('sidebarCollapsed', isCollapsed);
  setLocalStorageItem('isB2BFansMode', isB2BFansMode);

  return (
    <SidebarContext.Provider
      value={{
        isShow,
        setShow,
        isCollapsed,
        setIsCollapsed,
        isDarkModeEnabled,
        setIsDarkModeEnabled,
        isB2BFansMode,
        setIsB2BFansMode,
        showMemberOptions
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.any
};
